// @flow
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../../../reducers/appstate'
import type { PropsType, DispatchPropsType } from './PasswordReset'
import { PasswordReset } from './PasswordReset'
import { sendPasswordResetLinkAction } from '../../../actions/userActions'

type OwnPropsType = {
  theme: 'sand' | 'white',
  ctaColor?: string
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): any => {
  return ({
    resetPasswordErrorCode: state.resetPasswordErrorCode,
    resetPasswordErrorText: state.resetPasswordErrorText,
    resetPasswordEmailSent: state.resetPasswordEmailSent,
    resetPasswordEmail: state.resetPasswordEmail || '',
    theme: ownProps.theme,
    ctaColor: ownProps.ctaColor
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    resetPassword: (email: string): void => dispatch(sendPasswordResetLinkAction(email))
  }: DispatchPropsType)
}

export default connect<PropsType & DispatchPropsType, OwnPropsType, _, _, _, _>(mapStateToProps, mapDispatchToProps)(PasswordReset)
